var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadImgPre({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49967 14.6667H10.4997C13.833 14.6667 15.1663 13.3334 15.1663 10V6.00004C15.1663 2.66671 13.833 1.33337 10.4997 1.33337H6.49967C3.16634 1.33337 1.83301 2.66671 1.83301 6.00004V10C1.83301 13.3334 3.16634 14.6667 6.49967 14.6667Z",
    stroke: "#777777",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50033 6.66667C7.23671 6.66667 7.83366 6.06971 7.83366 5.33333C7.83366 4.59695 7.23671 4 6.50033 4C5.76395 4 5.16699 4.59695 5.16699 5.33333C5.16699 6.06971 5.76395 6.66667 6.50033 6.66667Z",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.28027 12.6334L5.56694 10.4267C6.09361 10.0734 6.85361 10.1134 7.32694 10.5201L7.54694 10.7134C8.06694 11.1601 8.90694 11.1601 9.42694 10.7134L12.2003 8.33341C12.7203 7.88675 13.5603 7.88675 14.0803 8.33341L15.1669 9.26675",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImgPre);
export default __webpack_public_path__ + "static/media/uploadImgPre.e804f8d6e632115d934c65c012abd0a4.svg";
export { ForwardRef as ReactComponent };